import {
  ADDITIONAL_INFO_1,
  ADDITIONAL_INFO_2,
  ADDITIONAL_INFO_2_INSURED,
  ADDITIONAL_INFO_2_CONTRACTOR,
  ADD_QUIZ_DPS,
  ADD_INFEXOFI,
  COUNTRY_OA,
} from "./actions";

const initialState = {
  additionalInfo1: [],
  additionalInfo2: [],
  additionalInfo2Insured: [],
  additionalInfo2Contractor: [],
  quizDPS: [],
  infexofi: {},
  countryOA: [],
};

const quizReducer = (state = initialState, action) => {
  const {
    type,
    additionalInfo1,
    additionalInfo2,
    additionalInfo2Insured,
    additionalInfo2Contractor,
    quizDPS,
    infexofi,
    countryOA,
  } = action;

  switch (type) {
    case ADDITIONAL_INFO_1:
      return { ...state, additionalInfo1 };
    case ADDITIONAL_INFO_2:
      return { ...state, additionalInfo2 };
    case ADDITIONAL_INFO_2_INSURED:
      return { ...state, additionalInfo2Insured };
    case ADDITIONAL_INFO_2_CONTRACTOR:
      return { ...state, additionalInfo2Contractor };
    case ADD_QUIZ_DPS:
      return { ...state, quizDPS };
    case ADD_INFEXOFI:
      return { ...state, infexofi };
    case COUNTRY_OA:
      return { ...state, countryOA };
    default:
      return state;
  }
};

export default quizReducer;
